module.exports = __webpack_public_path__ + "img/1454380351.7182f05f.jpg";